import React, {useRef} from 'react';
import {BuyerNote} from '../../Components/BuyerNote/BuyerNote';
import {CartItems} from '../../Components/CartItems/CartItems';
import {Coupon} from '../../Components/Coupon/Coupon';
import {Headline} from '../../Components/Headline/Headline';
import {OrderSummary} from '../../Components/OrderSummary/OrderSummary';
import {useControllerProps} from '../../ControllerContext';
import s from './CartBody.scss';
import {CheckoutButtons} from '../../Components/CheckoutButtons/CheckoutButtons';
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor';
import {CartScreenReaderMessage} from './CartScreenReaderMessage/CartScreenReaderMessage';
import {MinimumOrderAmount} from '../../Components/MinimumOrderAmount/MinimumOrderAmount';
import {SecureCheckout} from '../../Components/SecureCheckout/SecureCheckout';
import {Violations} from '../../Components/Violations/Violations';
import {useIsAfterHydration} from '../../../../../hooks/useIsAfterHydration';
import {SPECS} from '../../../../../domain/specs';

export const CartBody = () => {
  const {experiments} = useExperiments();

  const {
    shouldShowCoupon,
    shouldShowBuyerNote,
    shouldShowMinimumOrderAmount,
    shouldShowTopCheckoutButtonInMobile,
    shouldShowSecureCheckout,
    shouldDisplayViolations,
    shouldHideTopCheckoutButtonsForStudioAndEditorX,
    ShouldUseUseEffectOnShowTopButton,
  } = useControllerProps().cartStore;
  const {isMobile, isSSR} = useEnvironment();
  const cartBodyRef = useRef<HTMLDivElement>(null);

  let isStudioOrEditorXSite = false;

  const isAfterHydration = useIsAfterHydration() || !ShouldUseUseEffectOnShowTopButton;

  /* istanbul ignore next */
  if (shouldHideTopCheckoutButtonsForStudioAndEditorX && !isSSR) {
    const editorBrand = (window as any)?.commonConfig?.brand;
    isStudioOrEditorXSite = editorBrand === 'editorx' || editorBrand === 'studio';
  }

  let mainClassName = s.main;
  let summaryClassName = s.summary;

  /* istanbul ignore next */
  if (cartBodyRef.current?.clientWidth <= 920) {
    if (experiments.enabled(SPECS.UseGlobalCssForOneColumnCart)) {
      mainClassName = 'cartBodyMainOneColumn';
    } else {
      mainClassName = s.mainOneColumn;
    }
    summaryClassName = s.summaryOneColumn;
  }

  return (
    <main className={mainClassName} ref={cartBodyRef}>
      <section className={s.cart}>
        {isMobile && shouldShowTopCheckoutButtonInMobile && !isStudioOrEditorXSite && isAfterHydration && (
          <CheckoutButtons isOnTop />
        )}
        <Headline />
        <CartItems />
        <footer className={s.footer}>
          {shouldShowCoupon && (
            <div className={s.coupon}>
              <Coupon />
            </div>
          )}
          {shouldShowBuyerNote && (
            <div className={s.buyerNote}>
              <BuyerNote />
            </div>
          )}
        </footer>
        <CartScreenReaderMessage />
      </section>
      <aside className={summaryClassName}>
        <OrderSummary />
        {shouldDisplayViolations && <Violations />}
        {shouldShowMinimumOrderAmount && <MinimumOrderAmount />}
        <CheckoutButtons />
        {shouldShowSecureCheckout && <SecureCheckout />}
      </aside>
    </main>
  );
};
